export const STORAGE_MAIN_KEY = '@pillarNfts';
export const STORAGE_KEY = {
  CONNECTED_WALLET_ADDRESS: 'CONNECTED_WALLET_ADDRESS',
  CONNECTED_WALLET_PROVIDER: 'CONNECTED_WALLET_PROVIDER',
};
